import storeModule from '../../../store-module'
import { defineStore } from 'pinia'

export default defineStore(
  'active-offers-campaigns-performance',
  storeModule.createStoreModule('active-offers-campaigns-performance')
)
